import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@features/auth/model/use-auth';
import { FullPageSpinner } from '@shared/ui/Spinner';
import { paths } from '@app/router/paths';

/**
 * Gate for authenticated routes.
 *
 * While the stored token is being validated the status is `restoring`, and we
 * render a spinner rather than redirecting — otherwise every refresh would
 * bounce a signed-in admin to /login before the check completes.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isRestoring } = useAuth();
  const location = useLocation();

  if (isRestoring) {
    return <FullPageSpinner label="Restoring your session" />;
  }

  if (!isAuthenticated) {
    // Remember the attempted URL so login can send them back to it.
    return <Navigate to={paths.login} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
